import PageUpdated from './PageUpdated';

export default PageUpdated;
